
define('text!templates/awards-profile-link.html',[],function () { return '<li id="pa-awards">\n    <span><a href="/mod/awards/?uid=<%=userId%>"><%=Config.modules.awards.awardsGenitiveTitle%></a>:</span> <strong><%=awardsCount%></strong>\n</li>\n';});

